import axios from "../../config/axiosConfig";
import {
  DATE_WISE_PRODUCTION_STOCK_REPORT_REQUEST,
  DATE_WISE_PRODUCTION_STOCK_REPORT_SUCCESS,
  DATE_WISE_PRODUCTION_ROW_DETAIL_STOCK_REPORT_SUCCESS,
  DATE_WISE_PRODUCTION_STOCK_REPORT_FAILURE,
  DATE_WISE_PRODUCTION_STOCK_FILTER_REPORT_REQUEST,
  DATE_WISE_PRODUCTION_STOCK_FILTER_REPORT_SUCCESS,
  DATE_WISE_PRODUCTION_STOCK_FILTER_REPORT_FAILURE
} from "../types/date-wise-production-stock-report-types";

export const getDateWiseProductionStockReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DATE_WISE_PRODUCTION_STOCK_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        finyearId: params?.finyearId,
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };

      // Log the request parameters
      console.log('Request Param Datas >>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/date-wise-production/stock-report?${queryString}`;

      // Log the full URL (to debug)
      console.log('>>Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('<<<Purchase API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: DATE_WISE_PRODUCTION_STOCK_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching production detail yarn Report:", error);
        dispatch({ type: DATE_WISE_PRODUCTION_STOCK_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching production detail yarn Report:", error);
      dispatch({ type: DATE_WISE_PRODUCTION_STOCK_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getDateWiseProductionRowDetailStockReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DATE_WISE_PRODUCTION_STOCK_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        finyearId: params?.finyearId,
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };

      // Log the request parameters
      console.log('Request Param Datas >>>>>', requestParams);

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/date-wise-production/stock-report-row-details?${queryString}`;

      // Log the full URL (to debug)
      console.log('>>Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.get(fullUrl).then((response) => {
        console.log('<<<Purchase API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: DATE_WISE_PRODUCTION_ROW_DETAIL_STOCK_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching production detail yarn Report:", error);
        dispatch({ type: DATE_WISE_PRODUCTION_STOCK_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching production detail yarn Report:", error);
      dispatch({ type: DATE_WISE_PRODUCTION_STOCK_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getDateWiseProductionStockFilterDetail = (params) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: DATE_WISE_PRODUCTION_STOCK_FILTER_REPORT_REQUEST });

            const { auth } = getState();
            const defaultParams = {
                finyearId: auth.finyear?.id,
                companyId: auth.company?.id,
                customerId: auth.user?.Customer_Id,
            };
            const requestParams = { ...defaultParams };

            const queryString = new URLSearchParams(requestParams).toString();
            const fullUrl = `/production-detail-report/filter-detail/yarn?${queryString}`;

            console.log('<<Complete API Request URL: ', fullUrl);

            return axios.get(fullUrl).then((response) => {
                console.log('<<purchase-API Response Data: ', response);
                if (response.data) {
                  dispatch({ type: DATE_WISE_PRODUCTION_STOCK_FILTER_REPORT_SUCCESS, payload: response.data });
                }
            }).catch((error) => {
                console.error("Error fetching production detail yarn Report:", error);
                dispatch({ type: DATE_WISE_PRODUCTION_STOCK_FILTER_REPORT_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error("Error fetching production detail yarn Report:", error);
            dispatch({ type: DATE_WISE_PRODUCTION_STOCK_FILTER_REPORT_FAILURE, error: error.message });
        }
    };
};

export const clearDateWiseProductionStockReport = () => {
  return async (dispatch) => {
        dispatch({ type: DATE_WISE_PRODUCTION_STOCK_REPORT_SUCCESS, payload: {} });
  }
}
